import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { EmptyState } from '../empty-state';
interface UnexpectedErrorStateProps {
  title?: string;
  message?: string;
  className?: string;
}
export const UnexpectedErrorState: React.FC<UnexpectedErrorStateProps> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <EmptyState type="error" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};